import { createSelector } from "@reduxjs/toolkit";

const getCommonStore = (state) => state.common;

export const getUserAuthenticatedInfoFromStore = createSelector(getCommonStore, (common) => common.userAuthenticated);

export const getUserInfoFromStore = createSelector(getCommonStore, (common) => common.userInfo);

export const getSessionTime = createSelector(getCommonStore, (common) => common.sessionTime);
